const BahamasSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110836)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M12.1738 13.0435H38.7558C35.93 5.4275 28.5991 0 19.9999 0C14.4769 0 9.47746 2.23898 5.8584 5.85852L12.1738 13.0435Z"
        fill="#338AF3"
      />
      <path
        d="M12.1738 26.957H38.7558C35.93 34.573 28.5991 40.0005 19.9999 40.0005C14.4769 40.0005 9.47746 37.7616 5.8584 34.142L12.1738 26.957Z"
        fill="#338AF3"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110836">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BahamasSvg;
